
export default {
  props: {
    variant: {
      type: String,
      default: 'default' // gradient-secondary
    }
  }
}
